import React from 'react'
import { useState, useEffect } from 'react';
import { Box, Grid, Typography } from '@mui/material'
import IncidentKpis from './IncidentKpis'
import IncidentStatus from './IncidentStatus';
import NCRLog from './NCRLog';
import NearMissRateAgeing from './NearMissRateAgeing';
import IncidentAgeing from './IncidentAgeing';
import NCRAgeing from './NCRAgeing';
import IncidentClosureRateAgeing from './IncidentClosureRateAgeing';
import StopWorkAgeing from './StopWorkAgeing';
import NumberOfTrainings from './NumberOfTrainings';
import NumberOfSafetyAudit from './NumberOfSafetyAudit';
import BehaviourBasedSafetyScore from './BehaviourBasedSafetyScore';
import { useGetHSEKpisQuery } from 'store/slices/apis/hseDashboardSlice';
import { useParams } from 'react-router-dom';
import SimpleTable from 'components/SimpleTable';
import EHSTraining from './EHSTraining';
import Audit from './Audit';
import SafetyVisits from './SafetyVisits';
import ProjectLastUpdatedOn from "components/ProjectLastUpdatedOn";
import { useGetLastUpdatedOnStatusQuery } from "store/slices/apis/projectStatusApiSlice";
import { useGetHSEStatisticsQuery } from 'store/slices/apis/hseDashboardSlice';
import SafetyAuditTraining from "./SafetyAuditTraining";
import Incident from './incidentChart';
import EnviromentReorting from './enviromentReporting';
import SafeManHours from './safeManHoursChart';
import HseFindings from './hseFindingChart';
import HseTrainingConducted from './hseTrainingConductedChart';
import MoniteringAndMeasurement from './moniteringAndMeasurementChart';
import { useGetHSEDashBoardQuery } from 'store/slices/apis/hseDashboardSlice';
import { useLazyGetHSEListQuery, useGetHSEViewTypeListQuery } from "store/slices/apis/hseApiSlice";
import moment from 'moment';
import { useMemo } from 'react';
import { enterpriseTokens } from 'styles/theme';
// const zeroAccidentData = [
//     { label: "Fatal Incidents", value: 0 },
//     { label: "High Severity Incidents", value: 0 },
//     { label: "Medium Severity Incidents", value: 0 },
//     { label: "Low Severity Incidents", value: 0 },
//     { label: "Environmental Incidents", value: 0 },
// ];






const IncidentDashboard = () => {
    const { projectId } = useParams();
    const { data, isError, isFetching } = useGetHSEKpisQuery({ projectId });



    const transformHseData = (data = []) => {
        const monthFormat = "MMM YYYY";
        const monthsSet = new Set();
        const grouped = {};

        const allowedSections = ["Incident", "Environment Reporting"];

        data.forEach((item) => {

            if (!allowedSections.includes(item.section)) return;
            const month = moment(item.date).format(monthFormat);
            monthsSet.add(month);

            if (!grouped[item.section]) {
                grouped[item.section] = {};
            }

            if (!grouped[item.section][item.description]) {
                grouped[item.section][item.description] = {};
            }

            grouped[item.section][item.description][month] =
                (grouped[item.section][item.description][month] || 0) + item.value;
        });

        const months = Array.from(monthsSet).sort(
            (a, b) => moment(a, monthFormat) - moment(b, monthFormat)
        );

        return { grouped, months };
    };

    


    const [filters, setFilters] = useState({
        SortBy: "createdDate",
        SortOrder: "desc",
        PageNumber: 1,
        PageSize: 5000,
        ProjectId: projectId,
        Section: "",
        ViewType: "monthly",
        //IsResponseSharedWithAuthority: null,
    });

    const [triggerHSEList, { data: hseList, isFetching: isfetching }] = useLazyGetHSEListQuery();

    useEffect(() => {
        triggerHSEList(filters);
    }, []);

    const {grouped, months} = useMemo(() =>transformHseData(hseList?.data || []));




    const { data: hseData } = useGetLastUpdatedOnStatusQuery({ ProjectId: projectId });
    const { data: hseStatisticsData } = useGetHSEStatisticsQuery({ projectId });
    const { data: hseDashboardData } = useGetHSEDashBoardQuery({ projectId });

    const monitoringData = [
        { label: "No.of Emergency Mock drill conducted", value: hseStatisticsData?.data?.totalMockdrill },
        { label: "No.of Internal Audit by Third party or External Agency", value: hseStatisticsData?.data?.totalInternalAuditByThirdParty },
        { label: "No.of Site HSE Inspection conducted by Site & HSE manager.", value: hseStatisticsData?.data?.totalHSESiteInspection },
        { label: "No.of Inspection of lifting equipment,power tools etc.", value: hseStatisticsData?.data?.totalHeavyLiftingInspection },
        { label: "No. of Stop work notice issued", value: hseStatisticsData?.data?.totalStopWork }
    ]

    const environmentData = [
        // { label: "Zero Landfill", value: 0 },
        // { label: "Plastic Waste", value: 0 },
        // { label: "Hazardous Waste Management", value: 0 },
        // { label: "Enery Efficiency Initiatives", value: 0 },

        { label: "Number of Tree Planted (Sapling)", value: hseStatisticsData?.data?.totalTreePlanted },
        { label: "Renewble Energy consumed for construction", value: hseStatisticsData?.data?.totalRenewableEnergyConsumed },
        { label: "Total Hazardous waste", type: "progress", generated: hseStatisticsData?.data?.totalHazardousWasteGenerated, disposed: hseStatisticsData?.data?.totalHazardousWasteDisposed },
        { label: "Total Oil Waste", type: "progress", generated: hseStatisticsData?.data?.totalOilWasteGenerated, disposed: hseStatisticsData?.data?.totalOilWasteDisposed },
        { label: "Total Plastic Waste", type: "progress", generated: hseStatisticsData?.data?.totalPlasticWasteGenerated, disposed: hseStatisticsData?.data?.totalPlasticWasteDisposed },
        { label: "Total E-waste", type: "progress", generated: hseStatisticsData?.data?.totalEWasteGenerated, disposed: hseStatisticsData?.data?.totalEWasteDisposed },
    ];

    const formatNumber = (value) => {
        const num = Number(value ?? 0);

        if (Number.isInteger(num)) {
            return num;
        }

        return parseFloat(num.toFixed(2));
    };

    const kpis = {
        totalRecordedIncidents: Number(data?.data?.totalRecordedIncidents) ?? 0,
        totalFatilityCase: data?.data?.fatalIncidents ?  Number(data?.data?.fatalIncidents) : 0,
        // openNCRs: Number(data?.data?.openNCRs) ?? 0,
        // closedNCRs: Number(data?.data?.closedNCRs) ?? 0,
        totalSafeManHours: Number(data?.data?.totalSafeManHours) ?? 0,
        totalManHours: Number(data?.data?.totalManHours) ?? 0,
        ltifr: Number(data?.data?.ltifr) ?? 0,
        trir: Number(data?.data?.trir) ?? 0,
        nearMissIncidents: data?.data?.nearMissIncidents ? Number(data?.data?.nearMissIncidents) : 0,
        baheviorSafetyScore: Number(data?.data?.baheviorSafetyScore) ?? 0,
        legalCompliance: data?.data?.legalCompliance ? Number(data?.data?.legalCompliance) : "100%",
    }
    const nearMissFrequencyRate = formatNumber(data?.data?.nearMissFrequencyRate);
    const incidentClosureRate = formatNumber(data?.data?.incidentClosureRate);
    const numberOfStopWorkOrders = formatNumber(data?.data?.numberOfStopWorkOrders);
    const numberOfTrainings = Number(data?.data?.actualTrainings) ?? 0
    const numberOfPlannedTrainings = Number(data?.data?.plannedTrainings) ?? 0
    const numberOfSafetyAudits = Number(data?.data?.numberOfSafetyAudits) ?? 0
    const baheviorSafetyScore = Number(data?.data?.baheviorSafetyScore) ?? 0
    const legalCompliance = Number(data?.data?.legalCompliance) ?? 0

    return (
        <>
            <Grid container spacing={"10px"} sx={{ p: 0, pb: 6 }}>
                <Grid size={12} sx={{ bgcolor: "#fff", p: 2, pt: 2 }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexDirection: { xs: "column", md: "row" },
                                gap: 1,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: { xs: "18px", sm: "32px", md: "36px" },
                                    lineHeight: { xs: "16px", md: "48px" },
                                    color: "#252C32",
                                    fontFamily: "Outfit, sans-serif",
                                }}
                            >
                                HSE Performance
                            </Typography>
                        </Box>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: "14px",
                                lineHeight: "24px",
                                color: "#252C32",
                                fontFamily: "Outfit, sans-serif",
                            }}
                        >
                            Monitor workforce safety, assurance activity, incidents, and environmental compliance.
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={12} sx={{ px: 2 }}>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", pb: 0.75, borderBottom: `1px solid ${enterpriseTokens.lineSoft}`, "& .MuiTypography-root": { fontSize: "12px", color: enterpriseTokens.muted } }}>
                        <ProjectLastUpdatedOn date={hseData?.hse} />
                    </Box>
                </Grid>
                <Grid container columnSpacing={1.5} rowSpacing={1.5} sx={{ px: 2 }}>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <IncidentKpis kpis={kpis} isLoading={isFetching} isError={isError} />
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>

                        <SafetyAuditTraining data={hseStatisticsData?.data || []} />

                        {/* <Grid container spacing={2}>
                            <Grid size={{ xs: 12, md: 2.5 }}>
                                <Box
                                    sx={{
                                        background: "#fff",
                                        borderRadius: "8px",
                                        p: 0,
                                        // boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                                        border: "1px solid #E4E4E4",
                                        height: "100%",

                                    }}
                                >
                                    <EHSTraining data={hseStatisticsData?.data || []} />
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 12, md: 4.5 }}>
                                <Box
                                    sx={{
                                        background: "#fff",
                                        borderRadius: "8px",
                                        p: 0,
                                        // boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                                        border: "1px solid #E4E4E4",
                                        height: "100%",

                                    }}
                                >
                                    <Audit data={hseStatisticsData?.data || []}/>
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 12, md: 5 }}>
                                <Box
                                    sx={{
                                        background: "#fff",
                                        borderRadius: "8px",
                                        p: 0,
                                        // boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                                        border: "1px solid #E4E4E4",
                                        height: "100%",

                                    }}
                                > 
                                    <SafetyVisits data={hseStatisticsData?.data || []}/>
                                </Box>
                            </Grid>
                        </Grid> */}
                    </Grid>
                    <Grid container size={12}>
                        <Grid size={{ md: 6 }}>
                            <SafeManHours data={hseDashboardData?.data || []} />
                        </Grid>
                        <Grid size={{ md: 6 }}>
                            <HseFindings data={hseDashboardData?.data || []} />
                        </Grid>

                    </Grid>
                    <Grid container size={12}>
                        <Grid size={{ md: 4 }}>
                            <NearMissRateAgeing nearMissFrequencyRate={nearMissFrequencyRate} isLoading={isFetching} isError={isError} />
                        </Grid>
                        <Grid size={{ md: 4 }}>
                            <IncidentClosureRateAgeing incidentClosureRate={incidentClosureRate} isLoading={isFetching} isError={isError} />
                        </Grid>
                        <Grid size={{ md: 4 }}>
                            <StopWorkAgeing numberOfStopWorkOrders={numberOfStopWorkOrders} isLoading={isFetching} isError={isError} />
                        </Grid>
                    </Grid>
                    {/* <Grid container size={12}>
                        <Grid size={{ md: 6 }}>
                            <IncidentAgeing />
                        </Grid>
                        <Grid size={{ md: 6 }}>
                            <NCRAgeing />
                        </Grid>
                    </Grid> */}
                    {/* <Grid container size={12}>
                        <Grid size={{ md: 4 }}>
                            <NumberOfTrainings numberOfTrainings={numberOfTrainings} plannedTrainings={numberOfPlannedTrainings} isLoading={isFetching} isError={isError} />
                        </Grid>
                        <Grid size={{ md: 4 }}>
                            <NumberOfSafetyAudit numberOfSafetyAudits={numberOfSafetyAudits} isLoading={isFetching} isError={isError} />
                        </Grid>
                        <Grid size={{ md: 4 }}>
                            <BehaviourBasedSafetyScore baheviorSafetyScore={baheviorSafetyScore} isLoading={isFetching} isError={isError} />
                        </Grid>
                    </Grid> */}
                    <Grid container size={12}>
                        <Grid size={{ md: 6 }}>
                            {/* <SimpleTable heading='Monitoring and Measurement' data={monitoringData} /> */}
                            <Incident data={hseDashboardData?.data || []} months = {months} grouped = {grouped} />
                        </Grid>
                        <Grid size={{ md: 6 }}>
                            <EnviromentReorting data={hseDashboardData?.data || []}months = {months} grouped = {grouped} />
                        </Grid>
                    </Grid>

                    <Grid container size={12}>
                        <Grid size={{ md: 6 }}>
                            <HseTrainingConducted data={hseDashboardData?.data || []} />
                        </Grid>
                        <Grid size={{ md: 6 }}>
                            <MoniteringAndMeasurement data={hseDashboardData?.data || []} />
                        </Grid>

                    </Grid>
                </Grid>
            </Grid >
        </>
    )
}

export default IncidentDashboard
